import React, { useEffect } from "react";
import { ReactComponent as AddUserIcon } from "../../../assets/icons/management/adduser.svg";
import { IClient } from "../../../types/clients.type";
import { IProduct } from "../../../types/product.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddPhoneOrderForm from "../forms/AddPhoneOrderForm/AddPhoneOrderForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  clients: IClient[];
  products: IProduct[];
}

const AddPhoneOrderModal: React.FC<Props> = (props) => {
  const onApply = () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          onClose={props.onClose}
          title="Додати замовлення"
          subTitle="Додайте нове замовлення. Виберіть фото та заповніть необхідну інформацію."
          isLittleMargin={true}
        >
          <AddUserIcon />
        </ModalTitle>
        <AddPhoneOrderForm
          onApply={onApply}
          onClose={props.onClose}
          clients={props.clients}
          products={props.products}
        />
      </div>
    </DefaultModal>
  );
};

export default AddPhoneOrderModal;
